import { render } from "./miperfil.vue?vue&type=template&id=a8ffb4ae&scoped=true"
import script from "./miperfil.vue?vue&type=script&lang=js"
export * from "./miperfil.vue?vue&type=script&lang=js"

import "./miperfil.vue?vue&type=style&index=0&id=a8ffb4ae&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ffb4ae"]])

export default __exports__